import DEFAULT_ENUMS from './defaultEnums';

const statesEnum = DEFAULT_ENUMS.geography.us_states
.filter((state) => !['AS', 'UM', 'AA', 'AE', 'AP'].includes(state.value));

export default statesEnum;
